import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'app-interactive',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule
  ],
  templateUrl: './interactive.component.html',
  styleUrl: './interactive.component.scss'
})
export class InteractiveComponent {

}
